const classResolver = (oldClasses, newClasses) => {
  if (!newClasses) return oldClasses;
  const _oC = oldClasses.split(" ");
  const _nC = newClasses.split(" ");
  let _fC = [..._oC];
  _nC.forEach((x) => {
    const _x = x?.includes("-") ? x?.split("-")[0] : x;
    const fndC = _fC?.find((y) => {
      const _y = y?.includes("-") ? y?.split("-")[0] : [y];
      if (_y?.length > 0 && _x?.length > 0 && _y[0]?.length === _x?.length) {
        return (_y[0] + "-" + _y[1])?.includes(_x);
      }
      return _y[0]?.includes(_x);
    });
    if (fndC) {
      _fC = _fC?.filter((y) => y !== fndC);
    }
    _fC.push(x);
  });
  return _fC?.join(" ");
};

export default classResolver;
